// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1TBY2","title":"FrontImage_title__3q3mz"};